module.exports = __webpack_public_path__ + "static/media/cd2-icon-compliance-rate.eb5ef5fb.svg";